import { Moment } from 'moment';

export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}

export interface IFileDataMySuffix {
    id?: number;
    name?: string;
    fileId?: string;
    contenttype?: string;
    uploadedBy?: number;
    uploadedOn?: Moment;
    sizeInBytes?: number;
    activeStatus?: ActiveStatus;
    isFileExists?: boolean;
    contentType?: string; //used in support;
    base64String?: string;
}

export class FileDataMySuffix implements IFileDataMySuffix {
    constructor(
        public id?: number,
        public name?: string,
        public fileId?: string,
        public contenttype?: string,
        public uploadedBy?: number,
        public uploadedOn?: Moment,
        public sizeInBytes?: number,
        public activeStatus?: ActiveStatus,
        public contentType?: string,
        public base64String?: string
    ) {
        this.activeStatus = ActiveStatus.ACTIVE;
    }
}
